// Define and export the different types of request actions

// Action types for creating a request
export const ADD_REQUEST_REQUEST = "ADD_REQUEST_REQUEST";
export const ADD_REQUEST_SUCCESS = "ADD_REQUEST_SUCCESS";
export const ADD_REQUEST_FAILURE = "ADD_REQUEST_FAILURE";

// Action types for fetching requests
export const FETCH_REQUESTS_REQUEST = "FETCH_REQUESTS_REQUEST";
export const FETCH_REQUESTS_SUCCESS = "FETCH_REQUESTS_SUCCESS";
export const FETCH_REQUESTS_FAILURE = "FETCH_REQUESTS_FAILURE";

// Action types for fetching receipt uploads
export const FETCH_PENDING_UPLOAD_REQUESTS_REQUEST =
  "FETCH_PENDING_UPLOAD_REQUESTS_REQUEST";
export const FETCH_PENDING_UPLOAD_REQUESTS_SUCCESS =
  "FETCH_PENDING_UPLOAD_REQUESTS_SUCCESS";
export const FETCH_PENDING_UPLOAD_REQUESTS_FAILURE =
  "FETCH_PENDING_UPLOAD_REQUESTS_FAILURE";

// Action types for fetching receipt approvals
export const FETCH_PENDING_APPROVAL_REQUESTS_REQUEST =
  "FETCH_PENDING_APPROVAL_REQUESTS_REQUEST";
export const FETCH_PENDING_APPROVAL_REQUESTS_SUCCESS =
  "FETCH_PENDING_APPROVAL_REQUESTS_SUCCESS";
export const FETCH_PENDING_APPROVAL_REQUESTS_FAILURE =
  "FETCH_PENDING_APPROVAL_REQUESTS_FAILURE";

// Action types for fetching request types
export const FETCH_REQUEST_TYPES_REQUEST = "FETCH_REQUEST_TYPES_REQUEST";
export const FETCH_REQUEST_TYPES_SUCCESS = "FETCH_REQUEST_TYPES_SUCCESS";
export const FETCH_REQUEST_TYPES_FAILURE = "FETCH_REQUEST_TYPES_FAILURE";

// Action types for fetching request details
export const FETCH_REQUEST_DETAILS = "FETCH_REQUEST_DETAILS";
export const FETCH_REQUEST_DETAILS_SUCCESS = "FETCH_REQUEST_DETAILS_SUCCESS";
export const FETCH_REQUEST_DETAILS_FAILURE = "FETCH_REQUEST_DETAILS_FAILURE";

// Action types for updating a  request
export const UPDATE_REQUEST_REQUEST = "UPDATE_REQUEST_REQUEST";
export const UPDATE_REQUEST_SUCCESS = "UPDATE_REQUEST_SUCCESS";
export const UPDATE_REQUEST_FAILURE = "UPDATE_REQUEST_FAILURE";

// Action types for deleting a request
export const DELETE_REQUEST_REQUEST = "DELETE_REQUEST_REQUEST";
export const DELETE_REQUEST_SUCCESS = "DELETE_REQUEST_SUCCESS";
export const DELETE_REQUEST_FAILURE = "DELETE_REQUEST_FAILURE";

export const FETCH_REQUEST_PAYMENT_CODE = "FETCH_REQUEST_PAYMENT_CODE";
export const FETCH_REQUEST_PAYMENT_CODE_SUCCESS =
  "FETCH_REQUEST_PAYMENT_CODE_SUCCESS";
export const FETCH_REQUEST_PAYMENT_CODE_FAILURE =
  "FETCH_REQUEST_PAYMENT_CODE_FAILURE";

export const RESET_PAYMENT_CODE_DETAILS = "RESET_PAYMENT_CODE_DETAILS";

export const UPLOAD_RECEIPT_REQUEST = "UPLOAD_RECEIPT_REQUEST";
export const UPLOAD_RECEIPT_SUCCESS = "UPLOAD_RECEIPT_SUCCESS";
export const UPLOAD_RECEIPT_FAILURE = "UPLOAD_RECEIPT_FAILURE";
export const FETCH_RECEIPT_REQUEST = "FETCH_RECEIPT_REQUEST";
export const FETCH_RECEIPT_SUCCESS = "FETCH_RECEIPT_SUCCESS";
export const FETCH_RECEIPT_FAILURE = "FETCH_RECEIPT_FAILURE";

// New action types for approving receipt
export const APPROVE_RECEIPT_REQUEST = "APPROVE_RECEIPT_REQUEST";
export const APPROVE_RECEIPT_SUCCESS = "APPROVE_RECEIPT_SUCCESS";
export const APPROVE_RECEIPT_FAILURE = "APPROVE_RECEIPT_FAILURE";

// New action types for requiring receipt
export const REQUIRE_RECEIPT_REQUEST = "REQUIRE_RECEIPT_REQUEST";
export const REQUIRE_RECEIPT_SUCCESS = "REQUIRE_RECEIPT_SUCCESS";
export const REQUIRE_RECEIPT_FAILURE = "REQUIRE_RECEIPT_FAILURE";

// New action types for recalling request
export const RECALL_REQUEST_REQUEST = "RECALL_REQUEST_REQUEST";
export const RECALL_REQUEST_SUCCESS = "RECALL_REQUEST_SUCCESS";
export const RECALL_REQUEST_FAILURE = "RECALL_REQUEST_FAILURE";

// Action type for clearing requests errors
export const CLEAR_REQUESTS_ERROR = "CLEAR_REQUESTS_ERROR";
